import { createFileRoute } from "@tanstack/react-router";

import { parseMarketSearch } from "@/features/administration";
import { DispatchPage } from "@/features/administration/pages";
import { strictSearch } from "@/shared/lib/search";

/** How the search for a specialist is tuned, a market at a time. */
export const Route = createFileRoute("/_app/settings/dispatch")({
  validateSearch: strictSearch(parseMarketSearch),
  component: Dispatch,
});

function Dispatch() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DispatchPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
    />
  );
}
